export type ToastKind = 'info' | 'warn' | 'danger';

let container: HTMLDivElement | null = null;

function getContainer(): HTMLDivElement {
  if (container && document.body.contains(container)) return container;
  container = document.createElement('div');
  container.className = 'toast-stack';
  document.body.appendChild(container);
  return container;
}

export function showToast(message: string, kind: ToastKind = 'info', durationMs = 4000): void {
  const el = document.createElement('div');
  el.className = `toast${kind === 'danger' ? ' toast-danger' : kind === 'warn' ? ' toast-warn' : ''}`;
  el.textContent = message;
  getContainer().appendChild(el);
  setTimeout(() => el.remove(), durationMs);
}
